/**
 * This function rewrites a URL if it is a Matterport URL.
 * @param url The URL to rewrite.
 * @returns The rewritten URL, or the original URL if it is not a Matterport URL.
 */
export function rewriteUrl(url: URL): string {
  const originalUrl = url.toString();
  if (url.hostname !== "my.matterport.com") return originalUrl;

  // Extract model id and any existing sr/ss, then rebuild with the fixed format and params
  const modelId = url.searchParams.get("m");
  const existingSr = url.searchParams.get("sr");
  const existingSs = url.searchParams.get("ss");
  if (!modelId) return originalUrl;

  // Force path to /show/ and strip all existing params, including m and s
  const next = new URL(url.origin + "/show/");
  next.search = "";

  // Enforce exact parameter set and order
  next.searchParams.set("m", modelId);
  next.searchParams.set("cloudEdit", "1");
  next.searchParams.set("sr", existingSr && existingSr.length > 0 ? existingSr : ",-1.05");
  next.searchParams.set("ss", existingSs && existingSs.length > 0 ? existingSs : "6");
  next.searchParams.set("play", "1");
  next.searchParams.set("dh", "0");
  next.searchParams.set("fp", "0");
  next.searchParams.set("search", "0");
  next.searchParams.set("vr", "0");
  next.searchParams.set("tour", "2");
  next.searchParams.set("title", "0");

  return next.toString();
}
